import {useState} from "react";
import {Layout, LayoutChild} from '../../../../../palette/Palette';
import DateBox from 'devextreme-react/date-box';
import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import {daysFns} from '../../../../../utils/Utils';
import {db} from '../../../../../firebase/Firebase';
import {es} from 'date-fns/locale';
import axios from 'axios';
import {useSnackbar} from 'notistack';
import {SelectBox} from 'devextreme-react/select-box';
import List from 'devextreme-react/list';
import ArrayStore from 'devextreme/data/array_store';
import {LocalTaxiOutlined} from '@material-ui/icons';
import {LoadIndicator} from 'devextreme-react/load-indicator';
import {FilterDelete, Order} from '../../../../../utils/HelpFunctions';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import Alerts from '../../../../../palette/Alerts';
import {Button} from 'devextreme-react/button';
import Text from "../../../../../palette/Text";
import {ErrorMessage, NotiStackInfo} from "../../../../../palette/NotiStackInfo";
import subHours from 'date-fns/subHours'
import VerticalSpace from "../../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import difference from 'date-fns/differenceInMinutes'

const now = new Date();

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://data-routes-easi4xatjq-uc.a.run.app/data-routes';
//const url = 'http://127.0.0.1:5000/data-routes'
const urlEnabledVehicles = 'https://enabled-vehicles-easi4xatjq-uc.a.run.app/enabled-vehicles';

function RoutesDrivers(props) {

    const {
        getCoordsClient, companyName, idCompany, setSelectedItemKeys, valueDate, setValueDate, setVisibleGrid,
        selectedItemKeys, setDataList, dataList, setTotal, bookingAnticipation, setExists, setParcels, total,
        setDriverId, setHour, hour, setDriver, setVehicleData, setTokenPush, vehicleDisplay, setPhoto
    } = props;


    const [dataIds, setDataIds] = useState([]);
    const [dataHours, setDataHours] = useState([]);
    const [load, setLoad] = useState(false);
    const [loadHour, setLoadHour] = useState(false);
    const [showList, setShowList] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');
    const [checkDate, setCheckDate] = useState(true);

    const {enqueueSnackbar} = useSnackbar();

    const mainPath = db.collection(companyName).doc(idCompany);

    const backButton = () => {
        return (
            <Button icon="far fa-arrow-alt-circle-left" text="Volver" width={110}
                    onClick={() => {
                        setVisibleGrid(true)
                        setParcels(false)
                        setTokenPush([])
                    }}
            />
        )
    }

    const renderCancelButton = () => {
        return (
            <Layout row positionL>
                <Button id="cancel-button"
                        width={'100%'}
                        icon="fas fa-ban"
                        text="Cancelar viaje"
                        onClick={() => {
                            setVisibleGrid(true)
                            setParcels(false)
                            setTokenPush([])
                        }}/>
            </Layout>
        )
    }

    const CreateManualReservation = async (routeName, day, date, year, month, sameControl) => {

        const data = {routeName, day, companyName, idCompany, date, hour, year, month};

        setLoad(true);
        await axios.post(url, data, {headers: headers})
            .then(res => {
                const data = [...res.data.ids];
                if (!res.data.exists) {
                    setTextAlert(`No existen viajes disponibles para esta fecha en la ruta  ${routeName}`);
                    setLoad(false);
                    setShowAlert(true);
                    setDataList([]);
                    return;
                }
                if (data.length > 0) {

                    setLoad(false);
                    setShowList(false);
                    setShowAlert(false);
                    setSelectedItemKeys([]);

                    const hourArray = [];
                    data.forEach(item => {
                        hourArray.push(item.hour);
                    });

                    let ID = 0;
                    const hours = [];
                    const newArr = hourArray.filter((el, index) => hourArray.indexOf(el) === index);
                    newArr.forEach(item => {
                        ID = ID + 1;
                        const newObj = {ID: ID, hour: item};
                        hours.push(newObj);
                    });

                    const orderHours = Order(hours, 'hour');

                    let filterHours = []

                    orderHours.forEach(item => {
                        const currentDate = format(new Date(), 'yyyy/MM/dd');
                        const actualHour = format(new Date(), 'HH:mm')
                        const tripDateStr = `${currentDate} ${item.hour}`;
                        const myTrip = new Date(tripDateStr);
                        const diff = difference(myTrip, new Date())
                        if (diff >= bookingAnticipation) {
                            filterHours.push(item)
                        } else {
                            if (sameControl) {
                                filterHours = filterHours.filter(items => items.hour >= actualHour)
                            } else {
                                filterHours.push(item)
                            }
                        }
                    })

                    setDataHours(filterHours);

                    setDataHours(filterHours);

                    let id = 0;
                    const newArray = [];
                    data.map(async item => {
                        const docId = item['type_vehicle_id'];
                        await mainPath.collection('TypesVehicles').doc(docId).get()
                            .then(doc => {
                                id = id + 1;
                                const newObj = {
                                    ...item,
                                    id: id,
                                    description: doc.data().description,
                                    numberParcels: doc.data().numberParcels,
                                    availableSeats: doc.data().numberSeats,
                                    valueAdded: doc.data().valueAdded,
                                    seating: doc.data().seating,
                                    columns: doc.data().columns,
                                    exists: false,
                                };
                                newArray.push(newObj);
                            });
                        setDataIds([...newArray]);
                    });
                } else {
                    setLoad(false);
                    setDataIds([]);
                    setDataList([]);
                    setShowList(false);
                    setShowAlert(true);
                    setTextAlert('No existen viajes para esta fecha!');
                    setValueDate(null);
                    setTotal(0);
                }

            }).catch((e) => {
                console.log(e)
                setLoad(false);
                setShowList(false);
                setDataIds([]);
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
                setValueDate(null);
            });
    };
    const onValueChanged = async (e) => {

        const beforeControl = isBefore(e.value, now);
        const sameControl = isSameDay(now, e.value);
        setTokenPush([])
        setDataIds([]);

        if (!sameControl && beforeControl) {
            setShowList(false);
            setDataIds([]);
            setLoad(false);
            setValueDate(null)
            setCheckDate(false)
            return () => setCheckDate(false);
        }

        let dateOut = e.value;
        if (typeof (e.value) === 'string') {
            dateOut = new Date(dateOut);
        }

        if (e.value) {
            setCheckDate(true)
            const routeName = `${getCoordsClient.origenCity}-${getCoordsClient.destinyCity}`;
            const date = format(dateOut, 'yyyy-MM-dd');
            const year = format(dateOut, 'yyyy');
            const month = format(dateOut, 'MMMM', {locale: es});
            const day = daysFns[getDay(dateOut)];
            setValueDate(e.value);

            CreateManualReservation(routeName, day, date, year, month, sameControl).catch((e) => {
                console.log(e)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            });
        }
    };
    const onInitialized = (e) => {
        setTimeout(function () {
            e.component.focus();
        }, 0);
    };

    const dataSource = new ArrayStore({
        key: 'driverId',
        data: dataList,
    });

    const onValueChangedHour = async (e) => {
        const routeName = `${getCoordsClient.origenCity}-${getCoordsClient.destinyCity}`;
        const date = format(valueDate, 'yyyy-MM-dd');
        const year = format(valueDate, 'yyyy');
        const month = format(valueDate, 'MMMM', {locale: es});

        setLoadHour(true)

        const data = {
            routeName: routeName,
            companyName: companyName,
            idCompany: idCompany,
            date: date,
            hour: e.value,
            year: year,
            month: month,
            dataIds: dataIds,
            trip: false
        }

        await axios.post(urlEnabledVehicles, data, {headers: headers})
            .then(res => {
                const exists = res.data.exists;
                const result = res.data.result;

                if (exists) {
                    let orderList
                    if (vehicleDisplay === 'Orden') {
                        const order = result.sort((a, b) => {
                            return a.order - b.order;
                        });
                        orderList = [order[0]]
                    } else {
                        orderList = result
                    }
                    setDataList(orderList)
                    setHour(e.value);
                    setTotal(0);
                    setSelectedItemKeys([]);
                    setShowList(true);
                    setLoadHour(false)
                    setTokenPush([])
                } else {
                    let orderList
                    if (vehicleDisplay === 'Orden') {
                        const order = Order(result, 'order');
                        orderList = [order[0]]
                    } else {
                        orderList = Order(result, 'brand')
                    }
                    setDataList(orderList);
                    setShowList(true);
                    setHour(e.value);
                    setTokenPush([])
                    setSelectedItemKeys([]);
                    setTotal(0);
                    setLoadHour(false)
                }
            }).catch(() => {
                //console.error(err)
            })
    };

    const renderList = (data) => {

        const total = data.commissionRate;
        //setTotal(total);

        return (
            <Layout color={'transparent'} row center space>
                <div style={listStyles.divContainer}>
                    <LayoutChild color={'transparent'} center row>
                        <LayoutChild color={'transparent'} center>
                            <LocalTaxiOutlined style={{fontSize: 24, color: '#00BFFF'}}/>
                        </LayoutChild>
                        <LayoutChild color={'transparent'} positionR left={15}>
                            <Text hover={false} text={`${data.type_vehicle}`} size={12} color="#333" weight={'600'}/>
                            <Text hover={false} text={data.driver} size={9} color="gray" weight={'500'}/>
                            <Text hover={false} text={`${data.brand}, ${data.description}`} size={10} color="#333"
                                  weight={'600'}/>
                        </LayoutChild>
                    </LayoutChild>
                </div>
                <div style={{width: '40%'}}>
                    <LayoutChild color={'transparent'}>
                        <LayoutChild color={'transparent'} center row positionR>
                            <Text hover={false} text={`$ ${total}`} size={16} color="tomato" weight={'600'}/>
                        </LayoutChild>
                        <Text hover={false} text={`Número de encomiendas ${data.numberParcels}`} size={8}
                              color="green" weight={'600'}/>
                    </LayoutChild>
                </div>
            </Layout>
        );
    };

    const onSelectedItem = (e) => {

        const token = e.itemData.tokenPush

        if (!e.itemData.exists) {
            setTotal(e.itemData.commissionRate)
            setExists(e.itemData.exists)
            setVehicleData(e.itemData);
            setSelectedItemKeys([e.itemData.driverId]);
            setDriver(e.itemData.driver);
            setDriverId(e.itemData.driverId);
            setPhoto(e.itemData.photo)
            setTokenPush(e.itemData.tokenPush)
        } else {
            setExists(e.itemData.exists)
            setTotal(e.itemData.commissionRate)
            setVehicleData(e.itemData);
            setSelectedItemKeys([e.itemData.driverId]);
            setDriverId(e.itemData.driverId);
            setDriver(e.itemData.driver);
            setPhoto(e.itemData.photo)
            setTokenPush(typeof token === 'string' ? token : e.itemData.tokenPush[0])
        }
    }

    return (
        <>
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <Text hover={false} text={'Seleccionar fecha'} size={12}/>
                <DateBox type="date" onValueChanged={onValueChanged} value={valueDate} onInitialized={onInitialized}
                         elementAttr={{id: 'cb-dates',}} min={new Date()}/>

                {load &&
                <Layout color="transparent" center row>
                    <LoadIndicator id="small-indicator" height={20} width={20}/>
                    <span style={{color: 'gray', fontSize: 12}}>Buscando...</span>
                </Layout>}

                <VerticalSpace space={5}/>
                {dataIds.length > 0 &&
                <Layout color={'transparent'}>
                    {dataHours.length > 0 && <Text hover={false} text={'Seleccionar hora'} size={12}/>}
                    {dataHours.length > 0 ?
                        < SelectBox
                            dataSource={dataHours}
                            valueExpr="hour"
                            displayExpr="hour"
                            onValueChanged={onValueChangedHour}
                        /> :
                        <Layout color="transparent">
                            <Alerts severity="error" body={'Ya no existen horas de reserva'}/>
                        </Layout>
                    }
                </Layout>
                }

                <VerticalSpace space={10}/>
                {loadHour &&
                <Layout color="transparent" center row>
                    <LoadIndicator id="small-indicator" height={20} width={20}/>
                    <span style={{color: 'gray', fontSize: 12}}>Buscando...</span>
                </Layout>}
                <VerticalSpace space={5}/>

                {(dataIds.length > 0 && !showList && checkDate && !showAlert) && backButton()}
                {(dataIds.length === 0 && !showList && checkDate && !showAlert) && backButton()}

                {(showList && dataIds.length > 0) &&
                <Layout color={'transparent'}>
                    <Text hover={false} text={'Seleccionar vehículos disponibles'} size={14} color="#19598D"
                          weight={'700'}/>
                    <List
                        dataSource={dataSource}
                        showSelectionControls={true}
                        selectionMode={'none'}
                        selectedItemKeys={selectedItemKeys}
                        itemRender={renderList}
                        noDataText={'No existe disponibilidad de vehículos'}
                        onItemClick={onSelectedItem}>
                    </List>
                    <VerticalSpace space={20}/>
                    {total === 0 && renderCancelButton()}
                </Layout>
                }

                {!checkDate &&
                <Layout color="transparent">
                    <Alerts severity={'error'} body='No se puede escoger una fecha anterior a la fecha actual'/>
                    <div style={{height: 5}}/>
                    <Layout color="transparent" row positionL>
                        {backButton()}
                    </Layout>
                </Layout>
                }


                {showAlert &&
                <Layout color="transparent">
                    <Alerts severity="warning" body={textAlert}/>
                    <div style={{height: 5}}/>
                    <Layout color="transparent" row positionL>
                        {backButton()}
                    </Layout>
                </Layout>
                }

            </Animated>
        </>
    )

}


export default RoutesDrivers

const listStyles = {
    divContainer: {
        display: 'flex',
        width: '59%',
        wordWrap: 'break-word',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        flexDirection: 'row',
        alignItems: 'center',
    }
}